import React from "react";
import ExperienceCard from "./ExperienceCard/ExperienceCard";
import { experiences } from "../../data/ExperienceData";
import { ContactWrapper } from "../Contact/ContactElements";

const Experience = () => {
  return (
    <>
      <ContactWrapper id="experience">
        <div className="Container">
          <div className="SectionTitle">Experience</div>
          {experiences.map((exp, index) => (
            <ExperienceCard key={index} index={index} {...exp} />
          ))}
        </div>
      </ContactWrapper>
    </>
  );
};

export default Experience;
